
import Cookies from "js-cookie";
import { UserStore } from "../store/store";


export const clearOut = () =>
{
    localStorage.removeItem("favourites");
    localStorage.removeItem("video_list");
    localStorage.removeItem("application");
    localStorage.removeItem("inplayer_token");
    localStorage.removeItem("settings");
    localStorage.removeItem("page_image");
    localStorage.removeItem("page_title");
    localStorage.removeItem("color");
    localStorage.removeItem("font");
    localStorage.removeItem("prev_logo");
    localStorage.removeItem("foot_logo");

    Cookies.remove("sm_ott_val");
    UserStore.update(updateLog)
}

function updateLog (s)
{

  UserStore.update((s) => {
    s.NAME ="";
    s.EMAIL ="";
    s.PHONE="";
    s.PHONE_VERIFIED=false;
    s.WATCHHISTORY=[];
    s.FAVOURITES=[];
    s.COUNTRY=""
  }); 
}

export const setData = (fav,history,app,verify) =>
{
    fav?localStorage.setItem("favourites",fav):localStorage.setItem("favourites",JSON.stringify([]));
    history?localStorage.setItem("video_list",fav):localStorage.setItem("video_list",JSON.stringify([]));
    localStorage.setItem("application",app);

    const flag = verify==="true";
    Cookies.set('sm_ott_val',flag, { expires: 2 })

}
